import type { DraftValidationDetail } from "../../api/queries/adminQueries";

type DraftReviewSummaryProps = {
  detail: DraftValidationDetail;
};

export const DraftReviewSummary = ({ detail }: DraftReviewSummaryProps) => {
  if (!detail.user_feedback) {
    return null;
  }

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/80 p-4">
      <h3 className="text-sm font-semibold text-slate-700">User feedback</h3>
      {detail.user_feedback ? (
        <div className="mt-2 space-y-1 text-sm text-slate-600">
          <p>
            <span className="font-medium">Rating:</span>{" "}
            {detail.user_feedback.sentiment === "like" ? "Helpful" : "Not helpful"}
          </p>
          {detail.user_feedback.reason_category ? (
            <p>
              <span className="font-medium">Reason:</span>{" "}
              {detail.user_feedback.reason_category}
            </p>
          ) : null}
          {detail.user_feedback.feedback_text ? (
            <p>
              <span className="font-medium">Comments:</span>{" "}
              {detail.user_feedback.feedback_text}
            </p>
          ) : null}
        </div>
      ) : (
        <p className="mt-2 text-sm text-slate-500">No user feedback yet.</p>
      )}
    </div>
  );
};
